import { render, staticRenderFns } from "./RetrievePsd.vue?vue&type=template&id=c80621ae&scoped=true&"
import script from "./RetrievePsd.vue?vue&type=script&lang=js&"
export * from "./RetrievePsd.vue?vue&type=script&lang=js&"
import style0 from "./RetrievePsd.vue?vue&type=style&index=0&id=c80621ae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80621ae",
  null
  
)

export default component.exports